import { Injectable } from '@angular/core';
import {
  PROFILE_DATA_ID,
  PROFILE_DATA_LOCALE,
  PROFILE_DATA_NAME,
  PROFILE_DEFAULT_CURRENCY
} from '../../constants/constants';

export const TOKEN_KEY = 'authorization';
export const ID_KEY = PROFILE_DATA_ID;
export const USERNAME_KEY = PROFILE_DATA_NAME;
export const LOCALE_KEY = PROFILE_DATA_LOCALE;
export const CURRENCY_KEY = PROFILE_DEFAULT_CURRENCY;

@Injectable()
export class UserTokenService {
  setToken(token: string): void {
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  removeToken(): void {
    sessionStorage.removeItem(TOKEN_KEY);
  }

  setId(id: number): void {
    sessionStorage.setItem(ID_KEY, id.toString());
  }

  getId(): number {
    return Number(sessionStorage.getItem(ID_KEY));
  }

  removeId(): void {
    sessionStorage.removeItem(ID_KEY);
  }

  getName(): string {
    return sessionStorage.getItem(USERNAME_KEY);
  }

  setName(name: string): void {
    sessionStorage.setItem(USERNAME_KEY, name);
  }

  removeName(): void {
    sessionStorage.removeItem(USERNAME_KEY);
  }

  setLocale(locale: string): void {
    sessionStorage.setItem(LOCALE_KEY, locale);
  }

  removeLocale(): void {
    sessionStorage.removeItem(LOCALE_KEY);
  }

  setCurrency(currency: string): void {
    sessionStorage.setItem(CURRENCY_KEY, currency);
  }

  getCurrency(): string | null {
    return sessionStorage.getItem(CURRENCY_KEY);
  }

  removeCurrency(): void {
    sessionStorage.removeItem(CURRENCY_KEY);
  }

  removeStorage(): void {
    sessionStorage.clear();
  }
}
